start_point = 0
moveContainer = ->

    return false

    if start_point == 0
        start_point = $('#side_panel').offset().top

    doc_top = $(document).scrollTop()
    doc_width = $(document).width()

    # console.log doc_width


    side_panel = $('#side_panel')

    # pro mobily funci nepouzivame vuuubec
    if doc_width < 500
        side_panel.css
            'padding-top': '0px'
    else
        side_panel_height = $('#side_panel').height()
        panel_top_pos = side_panel.offset().top
        max_height = $('#all_reptisk').height()
        main_panel_height = $('#main_panel').outerHeight()



        if main_panel_height < side_panel_height && parseInt(side_panel.css('padding-top')) < 40
            
        else
            # 95 je vychozi padding
            if doc_top < (panel_top_pos + 35)
                side_panel.css
                    'padding-top': '35px'
                $('#themes_container_full').css
                    'top': '-150px'
            else
                top_padding = doc_top - panel_top_pos
                maximum_padding = main_panel_height - side_panel_height
                if top_padding > maximum_padding 
                    top_padding = maximum_padding
                side_panel.css
                    'padding-top': top_padding + 15 + 'px'
                $('#themes_container_full').css
                    'top': top_padding + 15 + 'px'

scrollTimer = null;

$(window).on 'scroll', ->
    moveContainer()

$('.themes_photo_product_select').click ->
    $('.themes_photo_product_select').removeClass 'active'

    $('#theme_selected_photo_product').val($(@).data('photo_product'))
    $('select[name=theme_selected_photo_product_mobile]').val($(@).data('photo_product'))
    
    $(@).addClass 'active'
    themesContainer.reload()

    return false

$('select[name=theme_selected_photo_product_mobile]').change ->
    $('.themes_photo_product_select').removeClass 'active'
    $('#theme_selected_photo_product').val($(@).val())
    themesContainer.reload()

show_theme_container = ->
    showLoader()
    $('#themes_container_full').addClass('shown')
    themesContainer.reload()

hide_theme_container = ->
    $('#themes_container_full').removeClass('shown')
    show_menu('photos_container')
    $('.app_menu a').removeClass 'active'
    $('.app_menu a[data-show=photos_container]').addClass 'active'
show_menu = (menu) ->
    deactivateTexts()
    
    $('.app_panel').removeClass 'shown'
    $('.app_panel[data-menu='+menu+']').addClass 'shown'
    console.log '.app_panel[data-menu='+menu+']'
    
    $('#app_container').addClass 'short_view'


close_menu = ->
    return false
    # $('.app_panel').removeClass 'shown'
    # $('#app_container').removeClass 'short_view'
    # $('#app_container').addClass 'full_view'
    # $('.app_menu a').removeClass 'active'


$('select#photo_ordering').change ->
    photoContainer.reload()

$(document).on 'click', '#close_themes_container_full', ->
    hide_theme_container()
    # photoContainer.reload()
    # $('.app_menu[data-show=photos_container]').addClass 'shown'
    return false

$('#toggle_hide_used').click ->

  el = $(@)

  selected = el.attr 'data-selected'
  new_value = if selected == '1' then '2' else '1'

  el.attr 'data-selected', new_value
  el.text el.data('value' + new_value + '_name')

  if new_value == '1'
    $('#hide_used').prop 'checked', true
  else
    $('#hide_used').prop 'checked', false

  $('#hide_used').trigger 'change'

  return false

$('#toggle_photo_filter').click ->

  el = $(@)

  selected = el.attr 'data-selected'
  new_value = if selected == '1' then '2' else '1'

  el.attr 'data-selected', new_value
  el.text el.data('value' + new_value + '_name')

  $('#photo_ordering')
    .val el.data('value' + new_value)
    .trigger 'change'

  return false

$('.app_menu a').click ->

    if $(@).data('show') != 'themes_container'
        hide_theme_container();


    if $(@).data('show') == 'photos_container'
        photoContainer.reload()

    if $(@).data('show') == 'layouts_container'
        layoutContainer.reload()

    if $(@).data('show') == 'shapes_container'
        shapesContainer.reload()

    if $(@).data('show') == 'backgrounds_container'
        backgroundsContainer.reload()

    if $(@).data('show') == 'texts_container'
        textsContainer.reload()

    if $(@).data('show') == 'user_shapes_container'
        userShapesContainer.reload()

    if $(@).data('show') == 'user_page_container'
        userPageContainer.reload()

    if $(@).data('show') == 'calendarium_container'
        calendariumContainer.reload()

    if $(@).data('show') == 'themes_container'
        show_theme_container();
        # themesContainer.reload()
    
    if $(@).hasClass 'active'
        close_menu()
    else
        show_menu ($(@).data 'show')
        $('.app_menu a').removeClass 'active'
        $(@).addClass 'active'
    false

